module.exports = __webpack_public_path__ + "img/520x.e9289d64.jpg";